import { call, Effect, put, takeLeading } from "redux-saga/effects"
import queryString from "query-string"
import humps from "humps"
import { normalize } from "normalizr"
import API from "../../../../apis/contextmeeting/api"
import { withAuthHeader } from "../../../../apis/contextmeeting/withAuthHeader"
import { tasksSchema } from "../../../../apis/contextmeeting/schema"
import { TasksActionTypes } from "../tasksTypes"
import { UserMessageTypes } from "../../../userMessage/state/userMessageTypes"
import { displayUserMessageAction } from "../../../userMessage/state/userMessageActions"

export function* fetchTasksAsync(action: Effect): Generator {
  try {
    const query = queryString.stringify(humps.decamelizeKeys(action.payload), { arrayFormat: "bracket" })
    const response: any = yield call(API.get, `/tasks?${query}`, withAuthHeader())
    const normalizedResponse = normalize(response.data.all, [tasksSchema])

    yield put({
      type: TasksActionTypes.FETCH_TASKS_ASYNC_SUCCESS,
      payload: {
        all: normalizedResponse,
        totalItems: response.data.totalItems,
        totalPages: response.data.totalPages,
        appliedFilters: response.data.searchQuery.appliedFilters,
        resultsPerPage: response.data.searchQuery.resultsPerPage,
        orderBy: response.data.searchQuery.orderBy
      }
    })
  } catch (error) {
    yield put({
      type: TasksActionTypes.FETCH_TASKS_ASYNC_ERROR,
      payload: error
    })

    yield put(displayUserMessageAction({
      messageKey: "tasksNotFound",
      type: UserMessageTypes.ERROR
    }))
  }
}

export function* watchFetchTasksAsync(): Generator {
  yield takeLeading(TasksActionTypes.FETCH_TASKS_ASYNC_PENDING, fetchTasksAsync)
}
